import findLastUpdatedAppt from 'utils/find-last-updated-appt.js';
import groupByApptStatus from 'utils/group-by-appt-status.js';

/**
 * @name ProjectListController
 * @description None
 * @param {unknown} Projects unknown
 * @param {unknown} Session unknown
 * @param {object} FormatAppointment Service to format appointments.
 * @param {unknown} _ Lodash service
 */
function ProjectsController(
  Projects,
  Session,
  FormatAppointment,
  _
) {
  let vm = this;

  // Public variables
  vm.confirmedProjects = [];
  vm.unconfirmedProjects = [];
  vm.requestedProjects = [];
  vm.noAppointmentsProjects = [];
  vm.completedProjects = [];
  vm.projectCount = null;
  vm.collector = Session.collector;

  // Get projects for collector when the controller loads */
  getProjects();

/**
 * Get projects
 * @param {string} role The role of the logged in user. This determines
 * data permissions on the endpoint.
 */
  function getProjects() {
    Projects.get().then(function(projects) {
      let groupedProjects = [];
      if (projects.length > 0) {
        let formatted = [];
        _.each(projects, function(project) {
          let data = {};
          data.project = project;
          data.project.appointments =
          _.each(project.appointments, function(appointment) {
            FormatAppointment.format(appointment);
          });
          data.appointment = findLastUpdatedAppt(project.appointments);
          formatted.push(data);
        });
        groupedProjects = groupByApptStatus(formatted);
      }
      vm.confirmedProjects = groupedProjects.confirmed;
      vm.unconfirmedProjects = groupedProjects.unconfirmed;
      vm.requestedProjects = groupedProjects.requested;
      vm.noAppointmentsProjects = groupedProjects.noAppointments;
      vm.completedProjects = groupedProjects.completed;

      // Display a project count on the view
      vm.projectCount =
        _.size(groupedProjects.confirmed) +
        _.size(groupedProjects.unconfirmed) +
        _.size(groupedProjects.requested) +
        _.size(groupedProjects.noAppointments) +
        _.size(groupedProjects.completed);
    });
  }
}

angular
  .module('inkfinder')
  .controller('ProjectsController', ProjectsController);



// WEBPACK FOOTER //
// ./components/projects/projects.controller.js